const initData = {
    id:0,
    recordId:0,
    axis:'',
}

const initialState = {   
    ...initData,
    sphere:'',
    cylinder:'',    
}

export const initialStateExtendSubj = {
    ...initialState,
    addition:'',
    avsc:'',
    avcc:'',
    dpl:'',
    dpc:'',
    convertion:''
}

export const initialStateExtendCiclo = {
    ...initialState,
    av:''      
}


export const initialStateExtendPrisma = {
    ...initData,
    prism : '',      
    base : '',      
}